import TenantService from '../../services/TenantService';
import tenantUseCase from './tenantUseCase';

const tenantFactory = tenantUseCase({
  TenantService: TenantService(),
});

export default tenantFactory;
